import { render, staticRenderFns } from "./PlantLocation.vue?vue&type=template&id=704bf7a2&"
import script from "./PlantLocation.vue?vue&type=script&lang=ts&"
export * from "./PlantLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports